export default __webpack_public_path__ + "static/media/thum6.01fc45be.jpg";